import { render, staticRenderFns } from "./Edit_partner.vue?vue&type=template&id=0d8b039e&scoped=true&"
import script from "./Edit_partner.vue?vue&type=script&lang=js&"
export * from "./Edit_partner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8b039e",
  null
  
)

export default component.exports